module.exports = __webpack_public_path__ + "media/images/front/icons/events-2a32c5ee3c8224326dff0f042b73c889.png";